import classNames from 'classnames'
import { GqlHealth } from 'src/services'
import { Text } from 'src/components/ui'
import { EvaluationText } from '../model-evaluation.const'
import { Badge } from './Badge'

type Props = {
  health: GqlHealth
  valueText?: string
  bottomComponent?: React.ReactNode
}

const boxStyles: Record<GqlHealth, string> = {
  GREEN: 'border-border-success-tertiary bg-[#F0FDF4]',
  YELLOW: 'border-border-warning-tertiary bg-background-warning-tertiary',
  RED: 'border-border-danger-tertiary bg-background-danger-tertiary/60',
}

export function createEvaluationBox(text: Record<GqlHealth, EvaluationText>) {
  return function EvaluationBox({
    health,
    valueText,
    bottomComponent,
  }: Props): JSX.Element {
    const { description, title } = text[health]

    return (
      <div
        className={classNames(
          'flex flex-col gap-xs px-m py-[12px] rounded-xs border border-solid w-[350px]',
          boxStyles[health],
        )}
      >
        <div className="flex items-center justify-between">
          <Text bold> {title}</Text>
          {valueText && <Badge health={health} text={valueText} />}
        </div>
        <Text variant="description">{description}</Text>
        {bottomComponent && <div>{bottomComponent}</div>}
      </div>
    )
  }
}
